const Konfetti = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={847}
    height={212}
    fill="none"
    {...props}
  >
    <path
      fill="#0397D8"
      d="M86 90v13l-19 6-1-11 20-8Zm613 105 11-2 8 15-9 2-10-15Z"
    />
    <path fill="#ADDDE4" d="m796 16 14-24-12-4-13 21 11 7Z" />
    <path fill="#0397D8" d="m428 15-17-7 9-15 14 5-6 17Z" />
    <path
      fill="#FEF200"
      d="m677 92-13 3-10-19 11-2 12 18Zm-130 49 5-13 23 1-5 12h-23Z"
    />
    <path fill="#ADDDE4" d="m449 189 5-11 20 2-4 10-21-1Z" />
    <path fill="#FEF200" d="m373 92 11-2 8 15-9 3-10-16Z" />
    <path
      fill="#FEF200"
      d="m530 57-11 8 28 22 8-5-25-25Zm161-35-9-11-15 22 6 8 18-19Zm96 89-11 4 15 19 8-3-12-20Zm68 1-9 11 27 10 6-8-24-13ZM155 29l6-8 16 7-6 7-16-6Zm91 41 1-10 16-3-1 9-16 4Z"
    />
    <path fill="#ADDDE4" d="m747 148 3-8 24 18-3 7-24-17Z" />
    <path fill="#FEF200" d="m359 143 9-10 20 8-8 10-21-8Z" />
    <path fill="#ADDDE4" d="m79 83 9-3 15 34-8 4-16-35Z" />
    <path
      fill="#fff"
      d="m573-13 14 5-6 29-14-5 6-29Zm144 97 9 15-25 24-10-15 26-24Z"
    />
    <path fill="#fff" d="m143 98-5 13-12-6 3-12 14 5Z" />
    <path fill="#ADDDE4" d="m331-13 17 21 8-9-15-19-10 7Z" />
    <path fill="#FEF200" d="m261 159-19-1 17-11 2 12Z" />
    <path fill="#ADDDE4" d="m181 172-11-16 19 7-8 9Z" />

    <path fill="#ADDDE4" d="m336 102-13 1-9-18 11-2 11 19Z" />
    <path
      fill="#FEF200"
      d="m59 26-6-14L71-3l5 12-17 17Zm401 45v12l-19 6V78l19-7Z"
    />
  </svg>
);
export default Konfetti;
